export const ADMIN_EMAILS = ["cyprien.conseillon@icloud.com"];
